import mergeWith from 'lodash/mergeWith';

function overrideArrayCustomizer(
  defaultValue: unknown,
  overrideValue: unknown
) {
  return Array.isArray(defaultValue) && Array.isArray(overrideValue)
    ? overrideValue
    : undefined;
}

function concatArrayCustomizer(defaultValue: unknown, overrideValue: unknown) {
  return Array.isArray(defaultValue) && Array.isArray(overrideValue)
    ? [...defaultValue, ...overrideValue]
    : undefined;
}

export function mergeObjectsButOverrideArrays<T = unknown, U = unknown>(
  base: T,
  overrides: U
) {
  return mergeWith({}, base, overrides, overrideArrayCustomizer);
}

export function mergeObjectsButConcatArrays<T = unknown, U = unknown>(
  base: T,
  overrides: U
) {
  return mergeWith({}, base, overrides, concatArrayCustomizer);
}
